import { Button, Container, Card, CardContent, Checkbox, FormControlLabel } from '@material-ui/core';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import logo from './../rcrm_logo.png';  // Update the path to your logo image
import './instruction.css';

const Instructions = () => {
    if (document.addEventListener) {
        document.addEventListener('contextmenu', function (e) {
        //   e.preventDefault();
        }, false);
    }
    const history = useHistory();
    const [agreed, setAgreed] = useState(false);

    const onAccept = () => {
        if (!agreed) return;
        history.push('/formvalid');
    };

    return (

<div className="App">
<img src={logo} alt="logo" className="App-logo" />
<br></br><br></br>
<Container className="instructions-container" maxWidth="md">
    <Card className="instructions-card">
    <CardContent>
    <h1 className="form-heading" id="enterExamCodeTxt">Assessment Instructions</h1>
    <p className="instructions-eligibility">
        <strong>Eligibility: Only candidates graduating in 2027 with a Bachelor&rsquo;s or Master&rsquo;s degree are
        eligible to apply for the Trainee Software Engineer role.</strong>
    </p>
    <ul className="instructions-list">
        <li>Attempt the test using the same email address you used to apply for the Trainee Software Engineer position.</li>
        <li>This is a live AI-proctored assessment. Your webcam must remain ON, and your face must be clearly visible throughout the test.</li>
        <li>You may keep a notebook and a pen/pencil with you during the assessment.</li>
        <li>Do not switch tabs, windows, applications, or use keyboard shortcuts (e.g., Alt+Tab, Cmd+Tab, Windows key, etc.).</li>
        <li>Do not log in from multiple devices.</li>
        <li>Do not leave your seat, move out of the camera's view, or move away from the screen during the assessment.</li>
        <li>Keep all prohibited items away, including mobile phones, smartwatches, calculators, and any other reference material.</li>
    </ul>
    <p className="instructions-disclaimer">
        <strong>Disclaimer:</strong> If any of the above activities are detected, your test will be automatically
        submitted, and your assessment may be cancelled or you may be disqualified from the hiring process.
    </p>
    {/* <p className="example-scenario">
        <strong>Response Format Example:</strong>  
        Question: What is the capital of France?
        <ul>
            <li> Berlin</li>
            <li> Madrid</li>
            <li> Paris</li>
            <li> Rome</li>
        </ul>
        Correct Response: C
    </p>
    <h3>Professional Conduct Guidelines:</h3>
    <ul className="instructions-list">
        <li>Maintain professional composure and focus throughout the assessment.</li>
        <li>Select a quiet, distraction-free environment for optimal performance.</li>
    </ul> */}
    <FormControlLabel
        className="instructions-agreement"
        control={
            <Checkbox
                id="agreeChk"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                color="primary"
            />
        }
        label={
            <span>
                I have read, understood, and agree to the above instructions. By clicking "Start Assessment",
                I acknowledge that any violation of these rules may result in automatic submission, cancellation
                of my assessment, or disqualification from the hiring process.
            </span>
        }
    />
    <p className="example-note">
        Best of luck with your assessment.
    </p>
    <div className="accept-button-container">
        <Button id="acceptBtn" className="accept-container-button" variant="contained" color="primary" onClick={onAccept} disabled={!agreed}>
            Start Assessment
        </Button>
    </div>
</CardContent>

    </Card>
</Container>
</div>

    );
};

export default Instructions;
